module.exports = __webpack_public_path__ + "static/img/book35.9082e6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book35.jpg
// module id = 174l
// module chunks = 1